module.exports = __webpack_public_path__ + "img/honor3.35cb219e.png";